export default class WeatherWarningHelper {
  public static getIconUrlForCode(code: number, iconId?: string): string {
    const normalizedIconId = (iconId || '').trim();
    if (normalizedIconId.length > 0) {
      return `https://openweathermap.org/img/wn/${normalizedIconId}@2x.png`;
    }

    const fallbackIconId = this.getFallbackIconIdForCode(code);
    return `https://openweathermap.org/img/wn/${fallbackIconId}@2x.png`;
  }

  public static getWarningForCode(code: number): string | null {
    if (!Number.isFinite(code)) return null;

    // see codes at https://openweathermap.org/api/weather-conditions

    // Thunderstorm group (2xx)
    if (code >= 200 && code < 300) {
      return 'thunderstorm conditions';
    }

    // Legacy extreme range in older OpenWeather responses.
    if (code >= 900) {
      return 'extreme weather conditions';
    }

    switch (code) {
      case 502:
      case 503:
      case 504:
      case 522:
      case 531:
        return 'dangerous rain conditions';
      case 511:
        return 'freezing rain conditions';
      case 602:
      case 622:
        return 'heavy snow conditions';
      case 762:
        return 'volcanic ash conditions';
      case 771:
        return 'squall conditions';
      case 781:
        return 'tornado conditions';
      default:
        return null;
    }
  }

  private static getFallbackIconIdForCode(code: number): string {
    if (!Number.isFinite(code)) return '01d';

    if (code >= 200 && code < 300) return '11d';
    if (code >= 300 && code < 400) return '09d';
    if (code >= 500 && code < 600) {
      if (code === 511) return '13d';
      if (code >= 520) return '09d';
      return '10d';
    }
    if (code >= 600 && code < 700) return '13d';
    if (code >= 700 && code < 800) return '50d';
    if (code === 800) return '01d';
    if (code === 801) return '02d';
    if (code === 802) return '03d';
    if (code === 803 || code === 804) return '04d';

    // Legacy extreme range in older OpenWeather responses.
    if (code >= 900) return '11d';

    return '01d';
  }
}
